document.addEventListener("DOMContentLoaded", function () {

  if (typeof Swiper !== "undefined") {

    new Swiper(".htReviewSlider", {

      loop: true,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },

      navigation: {
        nextEl: ".ht-next",
        prevEl: ".ht-prev",
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      slidesPerView: 3,
      spaceBetween: 8,

      breakpoints: {
  0: {
    slidesPerView: 3,
    spaceBetween: 5
  },
  768: {
    slidesPerView: 3,
    spaceBetween: 8
  },
  1024: {
    slidesPerView: 3,
    spaceBetween: 8
  }
}
    });

  }

});